import React from "react";
import { Container, Navbar } from "react-bootstrap";

const Footer = () => {
  return (
    <Navbar bg="secondary" variant="dark" className="mt-5">
      <Container className="justify-content-center text-center">

        <Navbar.Text>
          © {new Date().getFullYear()} Andrew Allemond
        </Navbar.Text>

        <Navbar.Text className="ms-3">
          <a
            href="https://github.com/aallemond"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "white", textDecoration: "none" }}
          >
            GitHub
          </a>
        </Navbar.Text>

        <Navbar.Text className="ms-3">
          <a
            href="https://linkedin.com/in/andrew-allemond1992"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "white", textDecoration: "none" }}
          >
            LinkedIn
          </a>
        </Navbar.Text>

      </Container>
    </Navbar>
  );
};

export default Footer;